import { Store } from '@ngrx/store';
import { resetErrorMessage, setErrorMessage, } from 'AlertsApp/ts/features/alerts-modals/state/alert-modal-status/alert-modal-status.actions';
import { createSystemAlert, deleteSystemAlert, } from 'AlertsApp/ts/features/alerts-modals/state/system-alert-items/system-alert-items.actions';
import { ALERTS_MODAL_STATE_SLICE_KEY } from 'AlertsApp/ts/features/alerts-modals/state/alerts-modal.reducer';
import { getAlertObject, getSystemAlerts } from 'AlertsApp/ts/features/alerts-modals/state/alerts-modal.selectors';
import { SYSTEM_ALERTS_OPTIONS } from 'AlertsApp/ts/features/alerts-modals/constants';
import { MODEL_PORTFOLIO, MULTI_WATCHLIST } from 'NewAngular/constants/core.constants';
import { AlertsService } from 'AlertsApp/ts/services/alerts.service';
import * as i0 from "@angular/core";
import * as i1 from "AlertsApp/ts/services/alerts.service";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/common";
function SystemAlertsListComponent_div_0_label_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 5)(1, "input", 6);
    i0.ɵɵlistener("click", function SystemAlertsListComponent_div_0_label_4_Template_input_click_1_listener($event) { const alertOption_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.handleSystemAlertToggle(alertOption_r2.alertType, $event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 7)(3, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const alertOption_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r2.isSystemAlertEnabled(alertOption_r2.alertType));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r2.getSystemAlertDescription(alertOption_r2));
} }
function SystemAlertsListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtext(2, "System Alerts");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵtemplate(4, SystemAlertsListComponent_div_0_label_4_Template, 4, 2, "label", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r2.supportedSystemAlerts);
} }
/**
 * SystemAlertsListComponent.
 *
 * List of system alerts available for the security or watchlist with a checkbox to enable or disable it for the user.
 *
 */
export class SystemAlertsListComponent {
    constructor(alertsService, store) {
        this.alertsService = alertsService;
        this.store = store;
        this.showSystemAlerts = false;
        this.systemAlertsList = [];
        this.supportedSystemAlerts = [];
        this.mapStateToComponent = (state) => {
            this.alertObject = getAlertObject(state);
            this.systemAlertsList = getSystemAlerts(state);
            if (this.alertObject !== undefined) {
                this.supportedSystemAlerts = this.getSupportedSystemAlerts();
                this.showSystemAlerts = this.supportedSystemAlerts.length > 0;
            }
        };
        this.storeSubscription = store.select(ALERTS_MODAL_STATE_SLICE_KEY).subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    /**
     * Returns true if the system alert should be checked when is within the registered system alerts.
     *
     * @param alertType: System alert type.
     */
    isSystemAlertEnabled(alertType) {
        return (this.systemAlertsList.length > 0 &&
            this.systemAlertsList.find((alert) => alert.alert_type === alertType) !== undefined);
    }
    /**
     * Handler for the system alert check.
     *
     * @param alertType: System alert type.
     * @param ev: Mouse event object with the `MouseEvent.target.checked` value.
     */
    handleSystemAlertToggle(alertType, ev) {
        // @ts-ignore
        const { checked } = ev.target;
        const alertToggle = { alertType, checked };
        this.toggleSystemAlert(alertToggle);
    }
    /**
     * Returns a list of the supported system alerts for the object type.
     */
    getSupportedSystemAlerts() {
        return SYSTEM_ALERTS_OPTIONS.filter((option) => {
            if (!this.alertObject)
                return [];
            return option.supportedDetailedTypes.includes(this.alertObject.detailedType);
        });
    }
    /**
     * Returns the description for a system alert.
     *
     * @param systemAlert: SystemAlertsOption object.
     */
    getSystemAlertDescription(systemAlert) {
        if (this.alertObject.type === MULTI_WATCHLIST) {
            return systemAlert.watchlistDescription;
        }
        if (this.alertObject.type === MODEL_PORTFOLIO) {
            return systemAlert.modelPortfolioDescription;
        }
        return systemAlert.description;
    }
    /**
     * Deletes or creates a system alert based on `SystemAlertsToggle.checked`.
     *
     * @param systemAlertsToggle: Contains the values for the checked HTML attribute and the selected system alert.
     */
    toggleSystemAlert(systemAlertsToggle) {
        if (systemAlertsToggle.checked) {
            this.createSystemAlert(systemAlertsToggle);
        }
        else {
            this.deleteSystemAlert(systemAlertsToggle.alertType);
        }
    }
    /**
     * Deletes a System Alert and dispatches `deleteSystemAlert` to remove it from the state.
     *
     * @param alertType: System alert type to be deleted.
     */
    deleteSystemAlert(alertType) {
        const selectedAlert = this.systemAlertsList.find((alert) => alert.alert_type === alertType);
        if (selectedAlert && this.systemAlertsList && this.alertObject) {
            this.alertsService
                .deleteAlert(selectedAlert.alert_type, this.alertObject.type, selectedAlert.id)
                .subscribe({
                next: () => {
                    this.store.dispatch(deleteSystemAlert({ alert: selectedAlert }));
                    this.store.dispatch(resetErrorMessage());
                },
                error: () => {
                    this.store.dispatch(setErrorMessage({
                        errorMessage: 'Alert deletion failed. Please refresh the page or contact support.',
                    }));
                },
            });
        }
    }
    /**
     * Creates a new System Alert with the system alert type from SystemAlertsToggle and the current object.
     * For system alerts, the params should be empty.
     *
     * Dispatches `createSystemAlert` to add the new system alert to the state.
     *
     * @param systemAlertsToggle: SystemAlertsToggle object containing the system alert type.
     */
    createSystemAlert(systemAlertsToggle) {
        if (this.alertObject) {
            this.alertsService
                .createAlert(systemAlertsToggle.alertType, this.alertObject.type, this.alertObject.id, {})
                .subscribe({
                next: (createAlert) => {
                    this.store.dispatch(createSystemAlert({ alert: createAlert.alert }));
                    this.store.dispatch(resetErrorMessage());
                },
                error: () => {
                    this.store.dispatch(setErrorMessage({
                        errorMessage: 'Alert creation failed. Please refresh the page or contact support.',
                    }));
                },
            });
        }
    }
}
SystemAlertsListComponent.ɵfac = function SystemAlertsListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SystemAlertsListComponent)(i0.ɵɵdirectiveInject(i1.AlertsService), i0.ɵɵdirectiveInject(i2.Store)); };
SystemAlertsListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SystemAlertsListComponent, selectors: [["ycn-system-alerts-list"]], standalone: false, decls: 1, vars: 1, consts: [["class", "modal-section notes-section", 4, "ngIf"], [1, "modal-section", "notes-section"], [1, "modal-section-title"], [1, "custom-controls-stacked"], ["class", "custom-control custom-checkbox", 4, "ngFor", "ngForOf"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "textContent"]], template: function SystemAlertsListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SystemAlertsListComponent_div_0_Template, 5, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showSystemAlerts);
    } }, dependencies: [i3.NgForOf, i3.NgIf], encapsulation: 2 });
